import CloseSave from "../../design/close";
import ContinerTrWorkers from "./ContinerTrWorkers";
import { useState } from "react";
import FetchMassage from "../../../faetures/FetchMassage";


function AppUsers({setClose, data, setAdd, id_office}) {

    const [massage, setMassage] = useState(
        {text: "", data: "", url: "", open: false, fun: () => {}}
    );

    const hendaleClickAddWorker = () => {
        setAdd();
    }

    return (
        <div className={"OfficeAndWorker-users"}>
            <div>
                <p> {data["name"]} </p>
                <CloseSave setClose={setClose} bc="white" c="black" />
            </div>

            <p className={"OfficeAndWorker-users-add-woker"} onClick={hendaleClickAddWorker}>הוסף עובד</p>

            <table>
                <thead>
                    <tr>
                        {
                            ["מס'", "שם", "אמייל", "טלפון", "משתמש", "", "", ""].map((keyTable, key) => (
                                <th key={key}> {keyTable} </th>
                            ))
                        }
                    </tr>
                </thead>

                <tbody>
                    {
                        Object.keys(data["workers"]).map((keyName, key) => (
                            <ContinerTrWorkers
                            key={keyName}
                            keyName={keyName}
                            data={data["workers"][keyName]}
                            keyCon={key}
                            setMassage={setMassage}
                            id_office={id_office}
                            />
                        ))
                    }
                </tbody>
            </table>

        {
            massage.open &&
            <FetchMassage
            text={massage.text}
            url={massage.url}
            data={massage.data}
            fun={massage.fun}
            setClose={() => setMassage({text: "", data: "", url: "", open: false, fun: () => {}})}
            setMassage={setMassage}
            />
        }
        </div>
    )
}


export default AppUsers;